
import { SliderBannerProductComponent } from './slider-banner-product/slider-banner-product.component';
import { SearchModule } from './search/search.module';
import { OtpverifyModule } from './otpverify/otpverify.module';
import { CheckoutModule } from './checkout/checkout.module';
import { GlobalService } from './global.service';
//import { ProductdetailsModule } from './productdetails/productdetails.module';

import { SubCategoryComponent } from './sub-category/sub-category.component';
import { EditprofileModule } from './editprofile/editprofile.module';
import { SigninModule } from './signin/signin.module';
import { RegisterModule } from './register/register.module';
import { NgModule,CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { ProductsComponent } from './products/products.component';
//import { ProductdetailsComponent } from './productdetails/productdetails.component';
//import { RegisterComponent } from './register/register.component';
//import { OtpverifyComponent } from './otpverify/otpverify.component';
import { ThankyouComponent } from './thankyou/thankyou.component';
import { CartComponent } from './cart/cart.component';
//import { CheckoutComponent } from './checkout/checkout.component';
import { NotificationComponent } from './notification/notification.component';
import { ProductlistComponent } from './productlist/productlist.component';
import { OrderComponent } from './order/order.component';
import { PaymentComponent } from './payment/payment.component';
import { WishlistComponent } from './wishlist/wishlist.component';
import { WalletComponent } from './wallet/wallet.component';
//import { SearchComponent } from './search/search.component';
import { AboutComponent } from './about/about.component';
import { SupportComponent } from './support/support.component';
import { ProductdetailsvariComponent } from './productdetailsvari/productdetailsvari.component';
import { WelcomeComponent } from './welcome/welcome.component';
import { WelcometwoComponent } from './welcometwo/welcometwo.component';
import { WelcomethreeComponent } from './welcomethree/welcomethree.component';
import { MakupcategoryComponent } from './makupcategory/makupcategory.component';
//import { MakupdetailsComponent } from './makupdetails/makupdetails.component';
import { MakuplistComponent } from './makuplist/makuplist.component';
import { DataService } from './data.service';
import { LoaderService } from './loder_service/loader.service';
import { Camera, CameraOptions } from '@ionic-native/camera/ngx';
import { IonicStorageModule } from '@ionic/storage';
import { Base64 } from '@ionic-native/base64/ngx';
import { Push, PushObject, PushOptions } from '@ionic-native/push/ngx';
import {  } from 'ionic4-star-rating';
//import { ProductdetailsModule } from './productdetails/productdetails.module';
import { StarRatingModule } from 'ionic4-star-rating';
import { SocialSharing } from '@ionic-native/social-sharing/ngx';

@NgModule({
  declarations: [
    AppComponent, 
    
    ProductsComponent,
    //ProductdetailsComponent,
    //RegisterComponent,
    //OtpverifyComponent,
    ThankyouComponent,
    CartComponent,
    //CheckoutComponent,
    NotificationComponent,
    ProductlistComponent,
    OrderComponent,
    PaymentComponent,
    WishlistComponent,
    WalletComponent,
    //SearchComponent,
    AboutComponent,
    SupportComponent,
    ProductdetailsvariComponent,
    WelcomeComponent,
    WelcometwoComponent,
    WelcomethreeComponent,
    MakupcategoryComponent,
    //MakupdetailsComponent,
    MakuplistComponent,
    SubCategoryComponent,
    SliderBannerProductComponent
  ],
  entryComponents: [],
  //schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    IonicStorageModule.forRoot(),
    AppRoutingModule,
    ReactiveFormsModule,
    HttpClientModule,
    RegisterModule,
    SigninModule,
    EditprofileModule,
    CheckoutModule,
    OtpverifyModule,
    SearchModule,
    StarRatingModule,
    
    //ProductdetailsModule
  ],
  providers: [
    StatusBar,
    SplashScreen,
    DataService,
    LoaderService,
    Camera,
    GlobalService,
    Base64,
    Push,
    SocialSharing,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
